import * as React from "react";
import PhoneInputBase from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "@/lib/utils";

/**
 * Shadcn-styled PhoneInput wrapper around react-phone-number-input.
 * - Shows country flag + dial-code selector on the left
 * - Auto-formats as the user types (based on selected country)
 * - Returns an E.164 string (e.g. "+919812345678") via onChange
 *
 * Props:
 *   value:       string | undefined  (E.164 format)
 *   onChange:    (e164: string | undefined) => void
 *   defaultCountry: e.g. "IN"
 *   id, name, placeholder, disabled, required
 */
export const PhoneInput = React.forwardRef(
  ({ className, defaultCountry = "IN", ...props }, ref) => {
    return (
      <PhoneInputBase
        ref={ref}
        international
        countryCallingCodeEditable={false}
        defaultCountry={defaultCountry}
        className={cn("phone-input", className)}
        numberInputProps={{
          className:
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        }}
        {...props}
      />
    );
  }
);
PhoneInput.displayName = "PhoneInput";

export { isValidPhoneNumber } from "react-phone-number-input";
export default PhoneInput;
